import { HttpHeaders } from "@angular/common/http";

// export const base_url = "http://localhost:4967/api"; //local
export const base_url = "https://apieauction.jaipurmc.org/api"; //Live Main

export const httpContenttype = {
  headers: new HttpHeaders({
    "Content-type": "application/json",
  }),
};
